<template>
  <div class="login-container h100">
    <div class="content flex-between flex-cross-center">
      <div class="cont-l">
        <div class="logo"></div>
        <div class="title">智能健康评估系统</div>
        <el-form ref="form" :model="form" class="form-wrap">
          <el-form-item class="mt40">
            <el-input
              v-model="form.loginName"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>

          <el-form-item class="mt40" prop="adminPwd">
            <el-input
              v-model="form.adminPwd"
              :type="showPwdFlag ? 'text' : 'password'"
              placeholder="请输入用户密码"
              @keyup.enter.native="onSubmit"
            >
              <i
                slot="suffix"
                @click="changeShowPwd"
                class="input__icon iconfont cursor"
                :class="{
                  'icon-bukejian': !showPwdFlag,
                  'el-icon-view': showPwdFlag,
                }"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item class="mt40">
            <el-button
              style="width: 100%"
              type="primary"
              @click="onSubmit"
              :loading="btnLoading"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="cont-r"></div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      form: {
        loginName: "",
        adminPwd: "",
      },
      btnLoading: false,
      formRules: {
        loginName: { required: true, message: "请输入用户名", trigger: "blur" },
        adminPwd: { required: true, message: "请输入密码", trigger: "blur" },
      },
      showPwdFlag: false,
    };
  },
  mounted() {},
  methods: {
    ...mapMutations([
      "setUserName",
      "setAppID",
      "setAccessToken",
      "setPermissions",
      "setAuthMap",
    ]),
    onSubmit() {
      // 假设成功
      let url = this.getApiUrl("adminLogin");
      let p = { ...this.form };
      this.btnLoading = true;
      this.axios
        .post(url, p, { pure: true })
        .then((res) => {
          let { code, msg, data } = res;
          if (code === 1) {
            if (data?.admin) {
              localStorage.setItem("admin", JSON.stringify(data?.admin));
            }
            data.userName = this.form.loginName;
            this.saveLoginData(data);
            let domain =
              process.env.NODE_ENV === "prod"
                ? ".miaohealth.net"
                : location.hostname;
            window.$setCookie("token", data.token, 10, "/", domain, false);
            window.$setCookie(
              "username",
              this.form.loginName,
              10,
              "/",
              domain,
              false
            );
            this.$root.setUserInfo();
            this.$root.token = data.token;
            this.$message.success("登录成功");
            window.$timer.clearTimeout();
            let isLoginPage = /\/login/.test(this.$route.query.redirect);
            window.$timer.setTimeout(() => {
              if (this.$route.query.redirect && !isLoginPage) {
                // window.location.href = this.$route.query.redirect;
              } else {
                if (data.permission.indexOf("sa_statics_home") == -1) {
                  this.$router.push({ path: "/welcome" });
                } else {
                  this.$router.push({ path: "/home" });
                }
              }
            }, 300);
          } else {
            this.$message.warning(msg);
          }
          this.btnLoading = false;
        })
        .catch((err) => {
          this.$message.error("登录失败");
          this.btnLoading = false;
          console.log(err);
        });
    },
    changeShowPwd() {
      this.showPwdFlag = !this.showPwdFlag;
    },
    //保存登录信息
    saveLoginData({ token, permission = "22", userName }) {
      console.log(userName);
      this.setUserName(userName);
      this.setAccessToken(token);
      if (permission) {
        // 删除首尾的|字符
        let _permission = permission.substring(1, permission.length - 1);
        let permissions = _permission.split("|");
        this.setPermissions(permissions);
        let map = {};
        permissions.forEach((item) => {
          map[item] = true;
        });
        this.setAuthMap(map);
      } else {
        this.setPermissions([]);
        this.setAuthMap({});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/color.scss";
.login-container {
  background: #ffffff;
  min-width: 1200px;
  min-height: 700px;
}
.cont-l {
  width: 42%;
  height: 449px;
  padding: 0 8%;
  box-sizing: border-box;
}
.cont-r {
  flex: 1;
  height: 100vh;
  min-height: 700px;
  flex-shrink: 0;
  background: url("./img/bg.png") no-repeat center right;
  background-size: contain;
}
.logo {
  height: 50px;
  background: url("./../../../public/img/logo_dark.png") no-repeat center left;
  background-size: auto 50px;
}
.title {
  font-size: 42px;
  font-weight: 500;
  margin-top: 10px;
}
</style>
